import React, { useState } from "react";
import { Form, Input, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import { httpService } from "../../../services/httpService.service";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import Done from "../../../Assets/svg/done.svg";
import ExclamationMark from "../../../Assets/svg/exclamationMark.svg";

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [email, setEmail] = useState("");
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  const handleForgotPassword = () => {
    setLoadingPage(true);
    form
      .validateFields()
      .then(() => {
        httpService.get(
          `/api/account/resendCode?email=${email}`,
          (response) => {
            const sucMessage =
              response.message || "Verification code sent to your email.";
            // message.success(sucMessage);
            setMessage({
              trigger: true,
              type: "success",
              icon: Done,
              title: `Verification code sent!`,
              text: sucMessage,
            });
            setTimeout(() => {
              setMessage({
                trigger: false,
              });
            }, 3000);

            setLoadingPage(false);
            navigate("/forgotPassword/code", { state: { email } });
          },
          (error) => {
            const errorMessage =
              error?.errors[0]?.message ||
              error?.message ||
              "An error occurred while sending the verification code.";
            setMessage({
              trigger: true,
              type: "danger",
              icon: ExclamationMark,
              title: "Oops! A problem has occurred!",
              text: errorMessage,
            });

            setTimeout(() => {
              setMessage({
                trigger: false,
              });
            }, 3000);

            setLoadingPage(false);
          }
        );
      })
      .catch((error) => {
        setLoadingPage(false);
        setMessage({
          trigger: true,
          type: "danger",
          icon: ExclamationMark,
          title: "Validation Error",
          text: "Please fill in the required fields correctly.",
        });
        setTimeout(() => {
          setMessage({
            trigger: false,
          });
        }, 3000);
      });
  };

  return (
    <div className="wrapper">
      <div className="row">
        <div className="col-md-6 left-column">
          <img
            src="/assets/svg/LoginImage.svg"
            alt="Login Visual"
            className="leftImage"
          />
        </div>
        <MessagePopUp
          trigger={message.trigger}
          type={message.type}
          icon={message.icon}
          messageTitle={message.title}
          messageText={message.text}
        />
        <div className="col-md-6 right-column">
          <div className="form-wrapper">
            <Spin spinning={loadingPage}>
              <h2>Forgot Password?</h2>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleForgotPassword}
              >
                <div className="mb-3">
                  <Form.Item
                    label="Email address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: "Please input a valid email!",
                      },
                    ]}
                  >
                    <Input
                      type="email"
                      className="form-control"
                      aria-describedby="emailHelp"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Item>
                  <div id="emailHelp" className="form-text">
                    We'll never share your email with anyone else.
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  loading={loadingPage}
                  disabled={loadingPage}
                >
                  Submit
                </button>
              </Form>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
